import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import ModelsIcon, { ModelIconProps } from '~/components/atoms/icon/ModelsIcon'
import InternalLink from '~/components/atoms/link/InternalLink'
import css from 'styled-jsx/css'
import { addClass } from '~/common/utils/html'

export interface NavigationTitleProps {
  title: string
  link: string
  iconProps: ModelIconProps
  color: SpaceColor
  hovered?: boolean
}

const NavigationHeaderTitle = ({title, link, iconProps, color, hovered = false}: NavigationTitleProps) => {
  const {className: colorClass, styles: colorStyles} = css.resolve`
    a { background-color: ${hovered ? lightenColor(color, ColorWeight.HEAVY) : color}; }
    a:hover { background-color: ${lightenColor(color, ColorWeight.HEAVY)}; }
    a:active { background-color: ${lightenColor(color, ColorWeight.MIDDLE)}; }
  `

  return (
    <InternalLink className={styles.headerTitle + addClass(colorClass)} link={link}>
      <ModelsIcon {...iconProps} size={iconProps.image ? IconSize.M_LARGE : IconSize.MEDIUM}
                  frame={IconFrame.SQUARE} bgColor={IconColor.WHITE} fillColor={color}/>
      <p className={styles.headerTitle__name}>{title}</p>
      {colorStyles}
    </InternalLink>
  )
}

export default NavigationHeaderTitle